import { render, staticRenderFns } from "./lyqc.vue?vue&type=template&id=52991d1f&scoped=true"
import script from "./lyqc.vue?vue&type=script&lang=js"
export * from "./lyqc.vue?vue&type=script&lang=js"
import style0 from "./lyqc.vue?vue&type=style&index=0&id=52991d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52991d1f",
  null
  
)

export default component.exports